import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import { AnimatedMessaging } from '../animation/MessagingAnimations';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { getInternationalizedImage } from '../images/internationalizedImages';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
const MessageImage = styled(UIImage).withConfig({
  displayName: "MessageImageCaption__MessageImage",
  componentId: "sc-16gwk9i-0"
})(["margin:0 auto;"]);

const MessageImageCaption = ({
  messageKey
}) => {
  const {
    imageKey,
    altText
  } = getMessage(messageKey);
  const locale = getApplicationLocale();
  const imageUrl = getInternationalizedImage(imageKey, locale);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(imageUrl);
  const attrs = {
    responsive: true,
    onLoad: handleImageLoaded,
    imageLoaded
  };

  if (Array.isArray(imageUrl)) {
    attrs.src = imageUrl[imageUrl.length - 1];
    attrs.srcSet = imageUrl.map((src, index) => `${src} ${400 * (index + 1)}w`).join(', ');
    attrs.sizes = '(max-width: 1200px) 100vw, 1200px';
  } else {
    attrs.src = imageUrl;
  }

  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    loaded: imageLoaded,
    children: /*#__PURE__*/_jsx(BaseMessageCaption, {
      messageKey: messageKey,
      children: /*#__PURE__*/_jsx(MessageImage, Object.assign({}, attrs, {
        alt: altText
      }))
    })
  });
};

export default MessageImageCaption;